import React from 'react';
import clsx from '@strava/ui/clsx';
import { OrDivider } from '@strava/authentication-ui';
import GetTheAppCTA from '../GetTheAppCTA';
import AuthenticationPanel from '../AuthenticationPanel';
import Header from '../Header';
import DownloadStrava from '../DownloadStrava';
import FollowAthleteCTA from '../FollowAthleteCTA';
import { useLoggedOutAthletePageContext } from '../../state/LoggedOutAthletePageContext';

import styles from './ProfileFollowersOnly.module.scss';

const ProfileFollowersOnly = () => {
  const { t } = useLoggedOutAthletePageContext();

  return (
    <div
      className={styles.profileFollowersOnly}
      data-testid="profile-followers-only"
    >
      <div className={styles.content}>
        <div className={styles.main}>
          <Header className={styles.mobileOnly} />
          <FollowAthleteCTA />
        </div>
        <div className={styles.secondary}>
          <AuthenticationPanel className={styles.authenticationPanel} />
          <OrDivider
            text={t('or')}
            theme="light"
            className={clsx(styles.orDivider, styles.desktopOnly)}
          />
          <GetTheAppCTA className={styles.desktopOnly} />
          <DownloadStrava className={styles.mobileOnly} />
        </div>
      </div>
    </div>
  );
};

export default ProfileFollowersOnly;
